import styled from 'styled-components';
import { landscape } from 'utils/responsive';

export default styled.div`
  position: absolute;
  top: 20%;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  width: 86%;
  margin: 0 auto;
  overflow-y: auto;

  ${landscape} {
    justify-content: flex-end;
  }
  color: ${({ theme }) => theme.colors.primary.light};
`;
